<template>
    <div class="view_group" v-if="!isDaumSearch || articles.length > 0">
        <h3 class="tit_group">
            <em class="emph_group">{{ mainTitle }}</em>{{ subTitle }}
        </h3>
        <div class="paging_group">
            <span class="inner_paging">
                <button type="button" class="btn_page btn_prev" id="btn_prev"><span class="ico_cafe ico_prev">이전</span></button>
                <span :class="pageClass(index)" v-for="(message, index) in pageMessages">{{ message }}</span>
                <button type="button" class="btn_page btn_next" id="btn_next"><span class="ico_cafe ico_next">다음</span></button>
            </span>
        </div>
        <div class="group_slide" id="linkageContents">
            <div class="swiper" ref="swiperEl">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="articles in pages">
                        <ul class="list_group">
                            <text-item v-for="article in articles" :article="article" :config="config"></text-item>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import TextItem from './TextItem.vue';

export default {
    components: {
        TextItem
    },
    props: {
        config: {
            type: Object
        },
        articles: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            ARTICLE_COUNT_PER_PAGE: 5,
            currentPage: 0,

            swiperInstance: null,
            swiperOptions: {
                navigation: {
                    prevEl: '#btn_prev',
                    nextEl: '#btn_next'
                }
            }
        };
    },
    computed: {
        svc() {
            return this.config.svcParam;
        },
        mainTitle() {
            if (this.config.isTopRank) {
                return '다른 실시간 인기글';
            } else if (this.isDaumSearch) {
                return this.config.searchKeyword;
            }
            return this.config.boardName;
        },
        subTitle() {
            if (this.config.isTopRank) {
                return '';
            } else if (this.isDaumSearch) {
                return ' 관련 카페글';
            }
            return ' 다른글';
        },
        isDaumSearch() {
            return this.config.isDaumSearch;
        },
        newArticles() {
            let newArticles = [...this.articles];
            let { prevArticle, currentArticle, isDaumSearch } = this.config;
            prevArticle = this.makeArticle(prevArticle);
            currentArticle = this.makeArticle(currentArticle);

            if (this.svc === 'topRank') {
                newArticles = [currentArticle, ...newArticles];
            } else if (!isDaumSearch && this.svc !== 'daumapp') {
                newArticles = [currentArticle, ...newArticles];
                if (parseInt(prevArticle.dataid) !== 0) {
                    newArticles = [prevArticle, ...newArticles];
                }
            }
            newArticles = newArticles.slice(0, 20);
            while (newArticles.length % 5 !== 0) {
                newArticles.push({ dummy: true });
            }
            return newArticles;
        },
        maxPage() {
            if (this.newArticles.length === 0) {
                return 0;
            }
            return Math.floor((this.newArticles.length - 1) / this.ARTICLE_COUNT_PER_PAGE);
        },
        pages() {
            const pages = new Array(this.maxPage + 1).fill([]);
            this.newArticles.forEach((article, index) => {
                const page = Math.floor(index / this.ARTICLE_COUNT_PER_PAGE);
                pages[page] = [...pages[page], article];
            });
            return pages;
        },
        pageMessages() {
            const messages = new Array(this.maxPage + 1).fill(0);
            return messages.map((message, index) => {
                if (this.currentPage !== index) {
                    return (index + 1).toString();
                }
                return `현재페이지 ${index + 1}`;
            })
        },
        swiper() {
            return this.swiperInstance;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initSwiper();
        });
    },
    beforeDestroy() {
        this.destroySwiper();
    },
    watch: {
        pages() {
            this.refreshSwiper();
        }
    },
    methods: {
        makeArticle(src) {
            return {
                dataid: src.dataid,
                fldid: src.fldid,
                name: src.dataname,
                commentCount: src.commentCount,
                grpcode: src.grpcode,
                parid: src.parid,
                current: src.current
            }
        },
        initSwiper() {
            if (!this.$refs.swiperEl) {
                return;
            }
            this.destroySwiper();
            const options = {
                ...this.swiperOptions,
                navigation: {
                    ...this.swiperOptions.navigation
                },
                modules: [Navigation],
                on: {
                    slideChange: () => {
                        this.onSlide();
                    }
                }
            };
            this.swiperInstance = new Swiper(this.$refs.swiperEl, options);
        },
        destroySwiper() {
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true);
                this.swiperInstance = null;
            }
        },
        refreshSwiper() {
	            this.$nextTick(() => {
	                if (!this.$refs.swiperEl) {
	                    return;
	                }
	                if (!this.swiperInstance) {
	                    this.initSwiper();
	                    return;
	                }
	                this.swiperInstance.updateSlides();
	                this.swiperInstance.update();
	                const maxPage = Math.max(this.maxPage, 0);
	                if (this.currentPage > maxPage) {
	                    this.currentPage = maxPage;
	                }
	                if (this.swiperInstance.slides && this.swiperInstance.slides.length > 0) {
	                    this.swiperInstance.slideTo(this.currentPage, 0);
	                }
	            });
	        },
        onSlide() {
            if (this.swiperInstance) {
                this.currentPage = this.swiperInstance.activeIndex;
            }
        },
        pageClass(page) {
            return {
                num_page: true,
                ['pslide' + (page + 1)]: true,
                page_on: page === this.currentPage
            }
        }
    }
}
</script>
